export const brands = ['AVEDA', 'MAC'];
